import { render, staticRenderFns } from "./DealsContactFund.vue?vue&type=template&id=45827011&"
import script from "./DealsContactFund.vue?vue&type=script&lang=js&"
export * from "./DealsContactFund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports